// #609: Reiter „Zuletzt hinzugefügt“ – alle neuen Dateien im Aktenschrank über alle Objekte, groß und filterbar
// (Zeitraum, Objekt, Herkunft, Suche). Gleiche Grundmenge wie das Widget: Drive-Datei mit Objekt, nicht gelöscht,
// nicht archiviert, ohne interne Ablage (02_Intern/…).
import { supabase } from '../supabase/client';
import { quelleLabel } from './aktenschrank';

export type Zeitraum = 'heute' | '7' | '30' | 'alle';
export type Herkunft = 'alle' | 'email' | 'app' | 'import';

export const ZEITRAEUME: { key: Zeitraum; label: string }[] = [
  { key: 'heute', label: 'Heute' }, { key: '7', label: '7 Tage' }, { key: '30', label: '30 Tage' }, { key: 'alle', label: 'Alle' },
];
export const HERKUENFTE: { key: Herkunft; label: string; tip: string }[] = [
  { key: 'alle', label: 'Alle', tip: 'Alle Herkünfte' },
  { key: 'email', label: 'Aus E-Mails', tip: 'Über „Zur Ablage“ aus E-Mail-Anhängen abgelegt' },
  { key: 'app', label: 'In der App', tip: 'Hochgeladen, Schreiben, Signatur, Übergabe' },
  { key: 'import', label: 'Import / Drive', tip: 'Altarchiv-Übernahme und direkt in Google Drive abgelegte Dateien' },
];

export interface ZuletztEintrag {
  id: string; titel: string | null; datei_name: string | null; kategorie: string | null; quelle: string | null;
  created_at: string; objekt_id: string; ablage_pfad: string | null; gdrive_file_id: string;
  mieter_id: string | null; eigentuemer_id: string | null; dokument_typ: string | null;
  objekt: { objektnummer: string | null; bezeichnung: string | null } | null;
}

/** Beginn des Zeitraums (lokaler Tagesanfang) als ISO-Zeitpunkt – null = ohne Grenze. */
export function zeitraumAb(z: Zeitraum, jetzt: Date = new Date()): string | null {
  if (z === 'alle') return null;
  const tage = z === 'heute' ? 0 : Number(z) - 1;
  const d = new Date(jetzt.getFullYear(), jetzt.getMonth(), jetzt.getDate() - tage);
  return d.toISOString();
}

/** Herkunft eines Eintrags für den Filter (spiegelt die Abfrage unten). */
export function herkunftVon(quelle: string | null): Exclude<Herkunft, 'alle'> {
  const q = (quelle ?? '').toLowerCase();
  if (q === 'email') return 'email';
  if (q === 'manuell' || q === 'uebergabe' || q === 'api') return 'app';
  return 'import';
}

/** Ordner-Anzeige „02 Finanzen › Mahnungen“ aus dem Ablagepfad. */
export function ordnerText(pfad: string | null): string {
  return (pfad ?? '').split('/').filter(Boolean).join(' › ');
}

export function herkunftText(e: Pick<ZuletztEintrag, 'quelle' | 'kategorie'>): string {
  return quelleLabel(e.quelle, e.kategorie);
}

export const SEITE = 60;

export async function ladeZuletzt(f: { zeitraum: Zeitraum; objektId: string | null; herkunft: Herkunft; suche: string }, seite: number): Promise<{ eintraege: ZuletztEintrag[]; mehr: boolean }> {
  let q = supabase.from('dokumente')
    .select('id, titel, datei_name, kategorie, quelle, created_at, objekt_id, ablage_pfad, gdrive_file_id, mieter_id, eigentuemer_id, dokument_typ, objekt:objekt_id(objektnummer, bezeichnung)')
    .not('gdrive_file_id', 'is', null).not('objekt_id', 'is', null).eq('is_deleted', false).neq('status', 'Archiviert')
    .not('ablage_pfad', 'like', '%_Intern/%');
  const ab = zeitraumAb(f.zeitraum);
  if (ab) q = q.gte('created_at', ab);
  if (f.objektId) q = q.eq('objekt_id', f.objektId);
  if (f.herkunft === 'email') q = q.eq('quelle', 'email');
  else if (f.herkunft === 'app') q = q.in('quelle', ['manuell', 'uebergabe', 'api']);
  else if (f.herkunft === 'import') q = q.or('quelle.is.null,quelle.not.in.(email,manuell,uebergabe,api)');
  for (const w of f.suche.trim().split(/\s+/).filter(x => x.length >= 2).slice(0, 5)) {
    const muster = `%${w.replace(/[%_,()]/g, ' ').trim()}%`;
    q = q.or(`datei_name.ilike.${muster},titel.ilike.${muster},kategorie.ilike.${muster}`);
  }
  const von = seite * SEITE;
  const { data, error } = await q.order('created_at', { ascending: false }).range(von, von + SEITE);
  if (error) throw new Error(error.message);
  const liste = (data ?? []) as unknown as ZuletztEintrag[];
  return { eintraege: liste.slice(0, SEITE), mehr: liste.length > SEITE };
}
